module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.a37b0c01.a37b0c0.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/geetest-ui/fonts/MaterialIcons-Regular.a37b0c01.ttf
// module id = 462
// module chunks = 14